module.exports = __webpack_public_path__ + "img/icon-tasks__select.337f4cc7.png";